import { Tabs_default } from "./chunk-XP7OMKGD.js";
import { Tabs_List_default } from "./chunk-ZUOUY6YG.js";
import { Tabs_Panel_default } from "./chunk-HCKLV3OD.js";
import { Tabs_Panels_default } from "./chunk-33H2CXSM.js";
import { Tabs_Tab_default } from "./chunk-XF2EVE7T.js";

// src/components/Tabs/index.ts
var TabComponent = Tabs_default;
TabComponent.Tab = Tabs_Tab_default;
TabComponent.Tab.displayName = "Tab.Tab";
TabComponent.List = Tabs_List_default;
TabComponent.List.displayName = "Tab.List";
TabComponent.Panel = Tabs_Panel_default;
TabComponent.Panel.displayName = "Tab.Panel";
TabComponent.Panels = Tabs_Panels_default;
TabComponent.Panels.displayName = "Tab.Panels";
export { TabComponent };